/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NavLink, useParams } from "react-router-dom";
import Select from 'react-select';
import Loader from "../../loader/Loader";
import AxiosController from "../../authentication/AxiosController";
import TableSelectStatus from "../sellings/orders/TableSelectStatus";
import TableSelectLabels from "../sellings/orders/TableSelectLabels";
import AdjustZeroModal from "../sellings/orders/AdjustZeroModal";
// import { lang } from "moment";
const get_shippingcosts = (
  slug,
  lang,
  token,
  shippingcostsHandler,
  handleLoader
) => {
  AxiosController.get(`api/${slug}/${lang}/get-shippingcost/`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((res) => {
      shippingcostsHandler(res.data);
      handleLoader(false);
    })
    .catch((e) => {});
};

const CustomerData = ({ CustomerData = {}, orders_handler = "" }) => {
  const { orderId, slug, lang } = useParams();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const employee_type = localStorage.getItem("employee_type");

  const [_] = useTranslation("global");
  const [loading, handleLoader] = useState(false);
  const [shippingcosts, shippingcostsHandler] = useState([]);
  const [showAdjustZeroModal, setShowAdjustZeroModal] = useState(false);
  const [internationalGovs, setInternationalGovs] = useState([]);
  const [loadingInternationalGovs, setLoadingInternationalGovs] = useState(false);
  const handleClose = () => {
    CustomerNewDataHandler(CustomerData);
    setShow(false);
  };

  const handleShow = () => {
    handleLoader(true);
    get_shippingcosts(slug, lang, token, (data) => {
      shippingcostsHandler(data);
      handleLoader(false);
      
      // If the order has a shipping_gov_id, fetch the international governorates
      const selectedGov = data.find(gov => gov.id === CustomerData.gov_id);
      if (selectedGov && selectedGov.is_international == 1 && selectedGov.shipping_currency_slug) {
        setLoadingInternationalGovs(true);
        AxiosController.get(`api/${selectedGov.shipping_currency_slug}/${lang}/get-shippingcost`, {
          headers: { Authorization: `Bearer ${token}` },
        })
          .then((res) => {
            setInternationalGovs(res.data);
            setLoadingInternationalGovs(false);
          })
          .catch((e) => {
            setLoadingInternationalGovs(false);
          });
      }
    }, handleLoader);
    setShow(true);
  };
  const constant_labels = (label, value, id = "", link = false) => {
    return (
      <div className="info-group d-flex flex-md-row flex-column gap-2">
        <div className="info-group d-flex gap-2">
          <span className="user-key">
            <p>{label} : </p>
          </span>
          <span className="user-value">
            {link ? (
              <NavLink
                style={{ color: "rgb(243, 168, 55)" }}
                to={`/${slug}/${lang}/panel/user/${id}`}
              >
                {value}
              </NavLink>
            ) : (
              <p>{value}</p>
            )}
          </span>
        </div>
      </div>
    );
  };
  const [show, setShow] = useState(false);
  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const [CustomerNewData, CustomerNewDataHandler] = useState(CustomerData);
  const [shippingcost, shippingcostHandler] = useState(
    CustomerNewData["shipping_cost"]
  );
  useEffect(() => {
    CustomerNewDataHandler(CustomerData);
  }, [CustomerData]);

  const update_customerData = () => {
    AxiosController.put(
      `api/${slug}/${lang}/order-client-update/`,
      {
        id: CustomerNewData.id,
        customer_name: CustomerNewData.customer_name,
        phone_1: CustomerNewData.phone_1,
        phone_2: CustomerNewData.phone_2,
        address: CustomerNewData.address,
        gov_id: CustomerNewData.gov_id,
        public_notes: CustomerNewData.public_notes,
        private_notes: CustomerNewData.private_notes,
        shipping_gov_id: CustomerNewData.shipping_gov_id || null,
        short_address: CustomerNewData.short_address || null,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        shippingcostsHandler(res.data);
        handleLoader(false);
        setShow(false);
        orders_handler();
      })
      .catch((e) => {});
  };
  return (
    <div className="header py-4 position-relative">
      <div
        className={`upper align-items-center d-flex flex-row gap-3`}
        dir={box_head_dir}
      >
        <div className="user-info col-6 align-self-center">
          {constant_labels(
            _("home.fullname"),
            CustomerData["customer_name"] ? CustomerData["customer_name"] : ""
          )}
          {constant_labels(
            _("home.phonenumber"),
            CustomerData["phone_1"] ? CustomerData["phone_1"] : ""
          )}
          {constant_labels(
            _("home.phonenumber2"),
            CustomerData["phone_2"] ? CustomerData["phone_2"] : ""
          )}
          {constant_labels(
            _("home.province"),
            CustomerData["arabic_name"] ? CustomerData["arabic_name"] : ""
          )}
          {constant_labels(
            _("home.address"),
            CustomerData["address"] ? CustomerData["address"] : ""
          )}
          {CustomerData["shipping_gov_ar_name"] && (
            constant_labels(
              _("home.shippingGovernorate") || "محافظة الشحن",
              CustomerData["shipping_gov_ar_name"]
            )
          )}
          {(CustomerData["short_address"] || slug === "sa") && (
            constant_labels(
              _("home.shortAddress") || "العنوان الوطني",
              CustomerData["short_address"] ? CustomerData["short_address"] : ""
            )
          )}
          {constant_labels(
            _("panel.orderNumber"),
            CustomerData["track"] ? CustomerData["track"] : ""
          )}
          {constant_labels(
            _("home.notesforclient"),
            CustomerData["public_notes"] ? CustomerData["public_notes"] : ""
          )}
          {constant_labels(
            _("home.notesformangment"),
            CustomerData["private_notes"] ? CustomerData["private_notes"] : ""
          )}
          {constant_labels(
            _("panel.refOrder"),
            CustomerData["reference_order"] ? CustomerData["reference_order"] : ""
          )}
          {role == "admin" || role == "employee"
            ? constant_labels(
                _("panel.themarketer"),
                CustomerData["marketer_id"]
                  ? `#${CustomerData["marketer_id"]} ${CustomerData["marketer_first_name"]} ${CustomerData["marketer_last_name"]}`
                  : "",
                CustomerData["marketer_id"],
                true
              )
            : ""}
          {constant_labels(
            _("panel.date"),
            CustomerData["created_at_formatted"]
              ? CustomerData["created_at_formatted"]
              : ""
          )}
          {role == "admin" || role == "employee"
            ? constant_labels(
                _("panel.confirmationUser"),
                CustomerData["first_name"]
                  ? CustomerData["first_name"] + " " + CustomerData["last_name"]
                  : ""
              )
            : ""}
          {role == "admin" || role == "employee"
            ? constant_labels(
                _("panel.courierTrack"),
                CustomerData["courier_track"] || CustomerData["courier_name"]
                  ? `${CustomerData["courier_track"]} ${CustomerData["courier_name"]}`
                  : ""
              )
            : ""}
        </div>
        <div>
          <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
            <div className="d-flex align-items-center gap-2 flex-column flex-md-row">
              {CustomerData["status"] === "Pending" &&
              CustomerData["canEdit"] ? (
                <Button
                  variant="primary"
                  className="my-3 rounded"
                  style={{
                    borderRadius: 0,
                    background: "rgb(243, 168, 55)",
                    color: "white",
                    border: "none",
                  }}
                  onClick={handleShow}
                >
                  {_("panel.editdetails")}
                </Button>
              ) : (
                ""
              )}
              {((role === "admin" || employee_type === "operation employee" || employee_type === "confirmation employee") && CustomerData["status"] === "Pending") && (
                <button
                  className="btn btn-sm btn-warning mt-1"
                  onClick={() => {
                    setShowAdjustZeroModal(true);
                  }}
                  style={{ fontSize: "12px" }}
                >
                  {_("panel.adjustZero")}
                </button>
              )}
              <TableSelectStatus
                currentStatus={CustomerData["status"]}
                handleLoader={handleLoader}
                orderId={CustomerData["id"]}
                orders_handler={orders_handler}
                canEdit={CustomerData["canEdit"]}
              />
            </div>
            {role == "employee" || role == "admin" ? (
              <TableSelectLabels
                handleLoader={handleLoader}
                currentLabel={CustomerData["label"]}
                currentStatus={CustomerData["status"]}
                orderId={CustomerData["id"]}
              />
            ) : (
              ""
            )}

            <Modal show={show} onHide={handleClose} centered size="md">
              <Loader active={loading} />

              <Modal.Header
                closeButton
                className="justify-content-between border-0"
                dir={box_head_dir}
              >
                <Modal.Title className="flex-grow-1">
                  {_("panel.editdetails")}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body dir={box_head_dir}>
                <div className="inputs-container">
                  {label_input(
                    _("home.fullname"),
                    CustomerNewData,
                    CustomerNewDataHandler,
                    "customer_name"
                  )}
                  {label_input(
                    _("home.phonenumber"),
                    CustomerNewData,
                    CustomerNewDataHandler,
                    "phone_1"
                  )}
                  {label_input(
                    _("home.phonenumber2"),
                    CustomerNewData,
                    CustomerNewDataHandler,
                    "phone_2"
                  )}
                  <div>
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.province")}
                    </label>
                    <Select
                      options={shippingcosts.map(gov => ({
                        value: gov.id,
                        label: `${gov.arabic_name} - ${gov.cost}`,
                        is_international: gov.is_international,
                        shipping_currency_slug: gov.shipping_currency_slug
                      }))}
                      onChange={(selectedOption) => {
                        CustomerNewDataHandler({
                          ...CustomerNewData,
                          gov_id: selectedOption.value,
                          shipping_gov_id: null, // Reset shipping gov when changing main gov
                        });
                        
                        // If international, fetch the shipping governorates
                        if (selectedOption.is_international == 1 && selectedOption.shipping_currency_slug) {
                          setLoadingInternationalGovs(true);
                          AxiosController.get(`api/${selectedOption.shipping_currency_slug}/${lang}/get-shippingcost`, {
                            headers: { Authorization: `Bearer ${token}` },
                          })
                            .then((res) => {
                              setInternationalGovs(res.data);
                              setLoadingInternationalGovs(false);
                            })
                            .catch((e) => {
                              setLoadingInternationalGovs(false);
                            });
                        } else {
                          setInternationalGovs([]);
                        }
                      }}
                      value={shippingcosts.find(gov => gov.id === CustomerNewData.gov_id) ? {
                        value: CustomerNewData.gov_id,
                        label: `${shippingcosts.find(gov => gov.id === CustomerNewData.gov_id).arabic_name} - ${shippingcosts.find(gov => gov.id === CustomerNewData.gov_id).cost}`
                      } : null}
                      isSearchable={true}
                      placeholder={_("home.province")}
                      noOptionsMessage={() => _("No options found")}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '42px',
                          height: '42px',
                          borderRadius: '0.375rem',
                          borderColor: '#ced4da',
                          '&:hover': {
                            borderColor: '#ced4da'
                          }
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          height: '42px',
                          padding: '0 8px'
                        }),
                        input: (base) => ({
                          ...base,
                          margin: '0px',
                        }),
                        indicatorsContainer: (base) => ({
                          ...base,
                          height: '42px'
                        })
                      }}
                    />
                  </div>
                  {label_textarea(
                    _("home.address"),
                    CustomerNewData,
                    CustomerNewDataHandler,
                    "address",
                    CustomerData["address"]
                  )}
                  {/* Shipping Governorate for international orders */}
                  {(internationalGovs.length > 0 || CustomerNewData.shipping_gov_id) && (
                    <div className="mb-3">
                      <label htmlFor="shippingGov" className="form-label">
                        {_("home.shippingGovernorate") || "محافظة الشحن"}
                      </label>
                      {loadingInternationalGovs ? (
                        <div className="text-center py-2">
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </div>
                      ) : (
                        <Select
                          options={internationalGovs.map(gov => ({
                            value: gov.id,
                            label: gov.arabic_name
                          }))}
                          onChange={(selectedOption) =>
                            CustomerNewDataHandler({
                              ...CustomerNewData,
                              shipping_gov_id: selectedOption ? selectedOption.value : null,
                            })
                          }
                          value={internationalGovs.find(gov => gov.id === CustomerNewData.shipping_gov_id) ? {
                            value: CustomerNewData.shipping_gov_id,
                            label: internationalGovs.find(gov => gov.id === CustomerNewData.shipping_gov_id)?.arabic_name
                          } : null}
                          isSearchable={true}
                          isClearable={true}
                          placeholder={_("home.selectShippingGov") || "اختر محافظة الشحن"}
                          noOptionsMessage={() => _("No options found")}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: '42px',
                              height: '42px',
                              borderRadius: '0.375rem',
                              borderColor: '#ced4da',
                              '&:hover': {
                                borderColor: '#ced4da'
                              }
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              height: '42px',
                              padding: '0 8px'
                            }),
                            input: (base) => ({
                              ...base,
                              margin: '0px',
                            }),
                            indicatorsContainer: (base) => ({
                              ...base,
                              height: '42px'
                            })
                          }}
                        />
                      )}
                    </div>
                  )}
                  {/* Short Address for SA orders */}
                  {(slug === "sa" || CustomerNewData.short_address || (shippingcosts.find(gov => gov.id === CustomerNewData.gov_id)?.shipping_currency_slug === "sa")) && (
                    label_input(
                      _("home.shortAddress") || "العنوان الوطني (Short Address)",
                      CustomerNewData,
                      CustomerNewDataHandler,
                      "short_address"
                    )
                  )}
                  {label_textarea(
                    _("home.notesforclient"),
                    CustomerNewData,
                    CustomerNewDataHandler,
                    "public_notes"
                  )}
                  {label_textarea(
                    _("home.notesformangment"),
                    CustomerNewData,
                    CustomerNewDataHandler,
                    "private_notes"
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer className="d-flex py-4 border-0">
                <Button
                  variant="primary"
                  className="flex-grow-1 py-2"
                  onClick={() => {
                    update_customerData();
                  }}
                >
                  {_("panel.save")}
                </Button>
                <Button
                  variant="primary"
                  className="flex-grow-1 py-2"
                  onClick={handleClose}
                  style={{ background: "rgb(243, 168, 55)" }}
                >
                  {_("panel.cancel")}
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
      
      <AdjustZeroModal
        showModal={showAdjustZeroModal}
        setShowModal={setShowAdjustZeroModal}
        orderId={CustomerData["id"]}
        handleLoader={handleLoader}
        orders_handler={orders_handler}
      />
    </div>
  );
};
const label_input = (label, CustomerNewData, CustomerNewDataHandler, prop) => {
  const handleChange = (e) => {
    CustomerNewDataHandler({ ...CustomerNewData, [prop]: e.target.value });
  };
  return (
    <div className="mb-3">
      <label htmlFor="exampleInputEmail1" className="form-label">
        {label}
      </label>
      <input
        type="text"
        className="form-control py-2 egp"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
        value={CustomerNewData[prop]}
        onChange={handleChange}
      />
    </div>
  );
};
const label_textarea = (
  label,
  CustomerNewData,
  CustomerNewDataHandler,
  prop
) => {
  const newCustomerData = { ...CustomerNewData };

  return (
    <div className="mb-3 d-flex flex-column">
      <label htmlFor="exampleInputEmail1" className="form-label">
        {label}
      </label>
      <textarea
        class="form-control"
        rows={3}
        onInput={(e) => {
          newCustomerData[prop] = e.target.value;
          CustomerNewDataHandler(newCustomerData);
        }}
      >
        {CustomerNewData[prop]}
      </textarea>
    </div>
  );
};

export default CustomerData;
